import React from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, Divider, Icon, Row} from 'antd';
import {getJobById} from './JobAPI';
import JobApplyForm from './JobApplyForm';
import LoadingIndicator from "../common/LoadingIndicator";

class JobDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job: {},
      isLoadingData: true
    }
  }

  mController = new AbortController();
  mSignal = this.mController.signal;

  componentDidMount = async () => {
    await getJobById(this.props.match.params.id, {signal : this.mSignal}).then(response => {
        this.setState({
          job: response.object,
          isLoadingData: false
        });
    }).catch(() => {
        this.setState({
          isLoadingData: false
        });
        this.props.history.push('/notfound');
    });
  };

  componentWillUnmount() {
    this.mController.abort();
  }

  render() {
    if (this.state.isLoadingData) {
      return <LoadingIndicator/>;
    }
    
    const { job, isLoadingData } = this.state;
    const { vacancyFunction :jobFunction = {}} = job;

    return(
      <>
        <h3><Link to="/"><Icon type="left" /> Back to job list</Link></h3>
        <Divider />
        <Row gutter={16}>
          <Col sm={{span:10}} style={{paddingBottom:'16px'}}>
            <Card title="Job Detail" loading={isLoadingData} id="job-detail">
              <p><strong>Position:</strong> {job.position}</p>
              <p><strong>Location:</strong> {job.location}</p>
              <p><strong>Job Function:</strong> {jobFunction.name}</p>
              <br />
              <div dangerouslySetInnerHTML={{__html: job.description}} />
            </Card>
          </Col>
          <Col sm={{span:14}}>
            <JobApplyForm history={this.props.history} vacancyId={job.id} />
          </Col>
        </Row>
      </>
    );
  }
}

export default JobDetail;